// extracted by mini-css-extract-plugin
module.exports = {"container":"_381ba80b"};